import React, { useState } from 'react';

import { CircularProgress, Typography, Checkbox } from '@material-ui/core';
import { ArrowDropUp, ArrowDropDown } from '@material-ui/icons';

import useWindowDimensions from 'helpers/hooks/useWindowDimensions';

export default function TableMobile({
  loading,
  selectCard = false,
  onSelectCard,
  data,
  actions
}) {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const [isAdvanced, setIsAdvanced] = useState(false);

  if(loading) {
    return(
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress
          color="primary"
          size={24}
        />
      </div>
    );
  }

  const getTemplateColumns = (item, hasAdvanced) => {
    const itemsLength = Object?.values(item)?.filter(item => !!item?.index)?.length;

    if(hasAdvanced) {
      if(isMobile) {
        return 'repeat(2, 1fr)';
      }
    }

    if(itemsLength >= 3) {
      return 'repeat(3, 1fr)';
    }

    return `repeat(${itemsLength}, 1fr)`;
  }

  return(
    <div style={{ width: '100%', padding: '10px 10px 0 10px' }}>
      {data?.map((item, itemIndex) => {
        const { onClick, backgroundColor } = item || {};
        const hasAdvanced = Object?.values(item)?.some(item => !!item?.advanced);

        return(
          <div
            key={item?.id || item?.paymentMethodId || item?.establishmentPaymentMethodId || itemIndex}
            onClick={onClick}
            style={{ width: '100%', display: 'flex', flexDirection: 'column', backgroundColor: backgroundColor || '#FCFCFC', border: '1px solid #D7D7D7', borderRadius: 5, marginBottom: 10, padding: 10, cursor: !!onClick ? 'pointer' : 'default'}}
          >
            <div style={{ width: '100%', display: 'grid', gridTemplateColumns: getTemplateColumns(item, false), gap: 15 }}>
              {Object?.values(item)?.filter(item => !!item?.index)?.filter(item => !item?.advanced)?.sort((a, b) => a?.index - b?.index)?.map(key => {
                return(
                  <div key={`${item?.id || item?.paymentMethodId || itemIndex}-${key?.index}`}>
                    <Typography color='primary' variant='subtitle2'>
                      {key?.label}
                    </Typography>
                    {key?.value}
                  </div>
                )
              })}
            </div>
            {isAdvanced && (
              <div style={{ width: '100%', display: 'grid', gridTemplateColumns: getTemplateColumns(item, hasAdvanced), gap: 15, marginTop: 10, paddingTop: 10, borderTop: '1px solid #D7D7D7' }}>
                {Object?.values(item)?.filter(item => !!item?.index)?.filter(item => !!item?.advanced)?.sort((a, b) => a?.index - b?.index)?.map(key => {
                  return (
                    <div key={`${item?.id || item?.paymentMethodId || itemIndex}-${key?.index}`}>
                      <Typography color='primary' variant='subtitle2'>
                        {key?.label}
                      </Typography>
                      {key?.value}
                    </div>
                  )
                })}
              </div>
            )}
            <div style={{ width: '100%', display: 'flex', justifyContent: selectCard ? 'space-between' : 'flex-end', alignItems: 'center' }}>
              {selectCard && (
                <Checkbox
                  style={{ padding: 0 }}
                  disabled={item?.disabledChecked}
                  checked={item?.checked}
                  onChange={() => onSelectCard(item)}
                />
              )}
              <div>
                {actions?.map(action => {
                  return action?.action(item);
                })}
              </div>
            </div>
            {hasAdvanced && (
              <div
                style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: 15, paddingTop: 5, borderTop: isAdvanced ? '0 none' : '1px solid #D7D7D7' }}
                onClick={() => setIsAdvanced(!isAdvanced)}
              >
                <button style={{ display: 'flex', alignItems: 'center', gap: 10, backgroundColor: 'transparent', border: '0 none', cursor: 'pointer' }}>
                  <Typography color='primary'>
                    <b>Mais opções</b>
                  </Typography>
                  {isAdvanced ? (
                    <ArrowDropUp />
                  ) : (
                    <ArrowDropDown />
                  )}
                </button>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}